const SVGComponent = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={20} height={20} rx={4} fill="#F4F4F5" />
    <g clipPath="url(#clip0_17608_19806)">
      <mask
        id="mask0_17608_19806"
        style={{
          maskType: "luminance"
        }}
        maskUnits="userSpaceOnUse"
        x={-27}
        y={4}
        width={71}
        height={20}
      >
        <path d="M-26.4883 4.12695H43.3183V23.0764H-26.4883V4.12695Z" fill="white" />
      </mask>
      <g mask="url(#mask0_17608_19806)">
        <mask
          id="mask1_17608_19806"
          style={{
            maskType: "luminance"
          }}
          maskUnits="userSpaceOnUse"
          x={4}
          y={4}
          width={12}
          height={12}
        >
          <path
            d="M4.15039 10.0053C4.15039 10.0053 4.15039 10.0053 4.15039 10.0017C4.15039 6.75822 6.7778 4.12695 10.0169 4.12695C13.2596 4.12695 15.8871 6.75822 15.8871 10.0017C15.8871 10.0053 15.8871 10.0053 15.8871 10.0053C15.8871 13.2489 13.2596 15.88 10.0169 15.88C6.7778 15.88 4.15039 13.2489 4.15039 10.0053Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_17608_19806)">
          <rect x={4.00781} y={4.00391} width={12.0181} height={11.9947} fill="#E8561B" />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_17608_19806">
        <rect width={12.0309} height={12} fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg>
)
export default SVGComponent
